export enum DictDataParamType {
  /**
   * ç§æ·
   */
  TENANT = 'tenant',

  /**
   * é¨é¨
   */
  DEPT = 'dept',

  /**
   * å°ç»
   */
  GROUP = 'group'
}
